export const emailTemplates = {
  // Template base que todos os emails usarão

  baseTemplate: (content) => `<!DOCTYPE html>
        <html lang="pt-BR">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Email Transacional</title>
            <style type="text/css">
                /* Resets para clientes de email */
                body, table, td,    div, p, a {
                    -webkit-text-size-adjust: 100%;
                    -ms-text-size-adjust: 100%;
                    margin: 0;
                    padding: 0;
                }
                
                table, td {
                    border-collapse: collapse;
                    mso-table-lspace: 0pt;
                    mso-table-rspace: 0pt;
                }
                
                img {
                    -ms-interpolation-mode: bicubic;
                    border: 0;
                    height: auto;
                    line-height: 100%;
                    outline: none;
                    text-decoration: none;
                }

                /* Estilos base */
                body {
                    height: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                    min-width: 100%;
                    background-color: #f4f4f4;
                }

                /* Estilos para dispositivos móveis */
                @media only screen and (max-width: 620px) {
                    .content-container {
                        width: 100% !important;
                    }
                    .fluid {
                        max-width: 100% !important;
                        height: auto !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                    }
                }
            </style>
        </head>
        <body style="margin: 0; padding: 0; background-color: #f4f4f4;">
            <!-- Preheader text (visível apenas em alguns clientes de email) -->
            <div style="display: none; max-height: 0; overflow: hidden;">
                <!-- Insira aqui o texto de previsualização do email -->
            </div>

            <!-- Tabela de fundo que ocupará toda a largura -->
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff;">
                <tr>
                    <td align="center" style="padding: 0;">
                        <!-- Container do conteúdo centralizado -->
                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 620px;" class="content-container">
                            <!-- Cabeçalho -->
                            <tr>
                                <td style="padding: 20px 0; text-align: center;">
                                    <!-- Insira aqui seu logotipo -->
                                    <img src="${
                                      process.env.VUE_APP_API_URL
                                    }/static/logo_avalioo.png" alt="Logo Avalioo" width="200" height="50" style="height: auto;">
                                </td>
                            </tr>

                            <!-- Conteúdo principal -->
                            <tr>
                                <td style="padding: 24px;">
                                    <div style="font-family: Arial, sans-serif; font-size: 16px; line-height: 1.5; color: #333333;">
                                        <!-- Área para conteúdo personalizado -->
                                        ${content}
                                    </div>
                                </td>
                            </tr>

                            <!-- Rodapé -->
                            <!--  <tr>
                                <td style="padding: 24px; text-align: center; border-top: 1px solid #eeeeee;">
                                    <p style="margin: 0; font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #666666;">
                                        Feito com ❤️ por Avalioo
                                    </p> -->
                                    <!-- Links de redes sociais ou informações adicionais podem ser inseridos aqui -->
                            <!--     </td>
                            </tr> -->
                        </table>
                    </td>
                </tr>
            </table>

            <!-- Informações legais (mantidas fora do fundo branco) -->
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 620px; margin: 0 auto;">
                <tr>
                    <td style="padding: 24px; text-align: center;">
                        <p style="margin: 0; font-family: Arial, sans-serif; font-size: 12px; line-height: 1.5; color: #666666;">
                            ©  ${new Date().getFullYear()} Feito com ❤️ por Avalioo. Todos os direitos reservados.<br>
                            <!-- Insira aqui seu endereço comercial -->
                        </p>
                    </td>
                </tr>
            </table>
        </body>
        </html>
        `,

  // Templates específicos
  welcomeEmail: (userName) => ({
    subject: "Bem-vindo ao Avalioo!",
    content: `
        <h1>Olá ${userName}!</h1>
        <p>Seja bem-vindo ao Avalioo. Estamos felizes em ter você conosco.</p>
        <p>Para começar, você pode...</p>
      `,
  }),

  npsConfirmation: ({ score, companyName }) => ({
    subject: `Obrigado pela sua avaliação - ${companyName}`,
    content: `
        <h1>Agradecemos sua avaliação!</h1>
        <p>Você deu a nota ${score} para ${companyName}.</p>
        <p>Sua opinião é muito importante para nós.</p>
      `,
  }),

  alertDetrator: ({
    score,
    review,
    datahora,
    companyName,
    branchName,
    contactName,
    contactPhone,
    contactWhatsapp,
    linkDiretoWhatsapp,
  }) => ({
    subject: `Avaliação - ${companyName}`,
    content: `
            <table border="1" cellpadding="8" cellspacing="0" style="width: 100%; border-collapse: collapse;">
                <thead>
                    <tr style="background-color: #f2f2f2;">
                        <th colspan="2" style="padding: 5px;">
                            <h2 style="margin: 0; padding-bottom: 15px; padding-top: 15px; ">Avaliação - ${companyName}</h2>
                        </th>
                    </tr>
                </thead>
                <tbody> 
                    <tr>
                        <td style="padding: 5px; padding-right: 15px; padding-bottom: 10px; padding-top: 10px;  text-align: right;"><strong>Unidade:</strong></td>
                        <td style="padding: 5px; padding-left: 15px; padding-bottom: 10px; padding-top: 10px; ">${branchName}</td>
                    </tr>
                    <tr>
                        <td style="padding: 5px; padding-right: 15px; padding-bottom: 10px; padding-top: 10px;  text-align: right;"><strong>Data da Avaliação:</strong></td>
                        <td style="padding: 5px; padding-left: 15px; padding-bottom: 10px; padding-top: 10px; ">${datahora}</td>
                    </tr>
                    <tr>
                        <td style="padding: 5px; padding-right: 15px; padding-bottom: 10px; padding-top: 10px;  text-align: right;"><strong>Quem avaliou:</strong></td>
                        <td style="padding: 5px; padding-left: 15px; padding-bottom: 10px; padding-top: 10px; ">${contactName}</td>
                    </tr>
                    <tr>
                        <td style="padding: 5px; padding-right: 15px; padding-bottom: 10px; padding-top: 10px;  text-align: right;"><strong>Telefone de Contato:</strong></td>
                        <td style="padding: 5px; padding-left: 15px; padding-bottom: 10px; padding-top: 10px; ">${contactPhone}</td>
                    </tr>
                    <tr>
                        <td style="padding: 5px; padding-right: 15px; padding-bottom: 10px; padding-top: 10px;  text-align: right;"><strong>Link direto para Whastapp:</strong></td>
                        <td style="padding: 5px; padding-left: 15px; padding-bottom: 10px; padding-top: 10px; ">${linkDiretoWhatsapp}</td>
                    </tr>

                    <tr>
                        <td style="padding: 5px; padding-right: 15px;   text-align: right; padding-bottom: 10px; padding-top: 10px; "><strong>Nota:</strong></td>
                        <td style="padding: 5px;  padding-left: 15px; padding-bottom: 10px; padding-top: 10px;  ">${score}</td>
                    </tr>
                    <tr>
                        <td style="padding: 5px; padding-right: 15px;   text-align: right; padding-bottom: 10px; padding-top: 10px; "><strong>Detalhamento:</strong></td>
                        <td style="padding: 5px;  padding-left: 15px;  padding-bottom: 10px; padding-top: 10px; ">${review}</td>
                    </tr>
                </tbody>
            </table>
        `,
  }),

  passwordReset: (resetLink) => ({
    subject: "Redefinição de senha solicitada",
    content: `
        <h1>Redefinição de senha</h1>
        <p>Você solicitou a redefinição de sua senha. Clique no link abaixo:</p>
        <a href="${resetLink}" style="background: #0066cc; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">
          Redefinir Senha
        </a>
        <p>Se você não solicitou esta redefinição, ignore este email.</p>
      `,
  }),
};
